import { WebDispatchProps } from "./web.props";

const webState: WebDispatchProps = {
  loading: {
    isLoading: false,
  },
  operationsPerDay: 0,
  arrayRandom20DarkColors: [],
  dispatch: () => null,
};

export default webState;
